// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1NHLN","item":"PaymentsMobile_item__2m3Qr","label":"PaymentsMobile_label__3oMr0","amount":"PaymentsMobile_amount__2H0h6"};